// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UmbTM1y6Cz_qssszoXla {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  pointer-events: all;
}

.WVEMJJrMxJp7aaci3B39 {
  display: flex;
  max-width: 100px;
  max-height: 100px;
  padding: 20px;
  background-color: rgba(21, 21, 21, 0.7);
  border-radius: 50%;
}
.WVEMJJrMxJp7aaci3B39 .gODBX19sTf_bSsHyEm2I {
  animation: Sy0RClG2WQIb9NuqVVMH 1s linear infinite;
}

.p9d1SP683rGiq4DIkiUy {
  width: 240px;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  overflow: hidden;
}

.FjC8_FEfr_feBB6A9Tg6 {
  height: 100%;
  background-color: #774dee;
  border-radius: 2px;
  transition: width 0.3s ease;
}

.bnrwOfyYDpLSpWOuOaeb {
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  color: #fff;
}

.wTDzG56PjBiUzxMgDRQ2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
}

.guN9t1hFdXUZlCfGXSSi {
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  color: #ff6b6b;
}

.vFUwLLA_bWlQZIWTAfet {
  display: flex;
  gap: 12px;
}

.vCRteF8XgyROlnM6aPOg,
.cJfu5yjNzPj0l8YEWqXi {
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
}

.vCRteF8XgyROlnM6aPOg {
  background-color: #774dee;
  color: white;
}
.vCRteF8XgyROlnM6aPOg:hover {
  background-color: #6a3de0;
}

.cJfu5yjNzPj0l8YEWqXi {
  background-color: transparent;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.cJfu5yjNzPj0l8YEWqXi:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

@keyframes Sy0RClG2WQIb9NuqVVMH {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(359deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/editor/components/modals/LoadingSceneModal/LoadingSceneModal.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,uCAAA;EACA,kBAAA;AAAF;AAEE;EACE,kDAAA;AAAJ;;AAIA;EACE,YAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WChCM;AD+BR;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;AADF;;AAIA;;EAEE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AADF;;AAIA;EACE,yBAAA;EACA,YAAA;AADF;AAGE;EACE,yBAAA;AADJ;;AAKA;EACE,6BAAA;EACA,YAAA;EACA,0CAAA;AAFF;AAIE;EACE,0CAAA;AAFJ;;AAMA;EACE;IACE,wBAAA;EAHF;EAKA;IACE,0BAAA;EAHF;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingModalWrapper": `UmbTM1y6Cz_qssszoXla`,
	"spinnerBox": `WVEMJJrMxJp7aaci3B39`,
	"spinner": `gODBX19sTf_bSsHyEm2I`,
	"spin": `Sy0RClG2WQIb9NuqVVMH`,
	"progressBarContainer": `p9d1SP683rGiq4DIkiUy`,
	"progressBar": `FjC8_FEfr_feBB6A9Tg6`,
	"message": `bnrwOfyYDpLSpWOuOaeb`,
	"errorContent": `wTDzG56PjBiUzxMgDRQ2`,
	"errorMessage": `guN9t1hFdXUZlCfGXSSi`,
	"errorButtons": `vFUwLLA_bWlQZIWTAfet`,
	"retryButton": `vCRteF8XgyROlnM6aPOg`,
	"dismissButton": `cJfu5yjNzPj0l8YEWqXi`
};
export default ___CSS_LOADER_EXPORT___;
